export default {
  auth:{
    isLoggedIn:false,
    isLoggedInAdthrive: false,
    activeSite: null,
    adthriveSites: []
  },
  briefs:{
    isLoading: false,
    briefs: [],
    activeBrief: {}
  },
  currentPage: {
    permalink: null,
    postId: null,
    isLoading: false,
    shouldTryAutoloading: true
  }
}